/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import fileTransferTemplate from './file-transfer.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.fileTransfer', [])
    .directive('tkGatewayFileTransfer', GatewayFileTransfer)
    .name;

/*@ngInject*/
function GatewayFileTransfer() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            gatewayId: '=',
            isReadOnly: '='
        },
        controller: GatewayFileTransferController,
        controllerAs: 'vm',
        templateUrl: fileTransferTemplate
    };
}

/*@ngInject*/
function GatewayFileTransferController($mdDialog, $scope, $element, $translate, toast, types, gatewayCommandService, fileTransferService) {
    var vm = this;

    vm.$onInit = function () {
        vm.types = types;
        vm.decompressFile = false;

        vm.fileUpload = fileUpload;
        vm.fileAdded = fileAdded;
    };

    $scope.$watch('vm.gatewayId', (newVal) => {
        if (newVal) {
            reload();
        }
    });

    function reload() {
        toast.hide();
        vm.fileName = null;
        vm.fileSize = null;
        vm.importData = null;
        vm.decompress = false;
    }

    function fileAdded($file) {
        fileTransferService.fileAdded($file, $scope).then(
            (fileInfo) => {
                vm.importData = fileInfo.importData;
                vm.fileName = fileInfo.fileName;
                vm.fileSize = fileInfo.fileSize;
            }
        );
    }

    function fileUpload() {
        var fileInfo = {
            importData: vm.importData,
            fileName: vm.fileName,
            fileSize: vm.fileSize,
            decompressFile: vm.decompressFile,
            isModemFw: false
        };

        fileTransferService.fileUpload(vm.gatewayId.id, fileInfo).then(
            (response) => {
                vm.importData = null;
                vm.fileName = null;
                vm.fileSize = null;
                vm.decompressFile = false;

                if (response === 'ok') {
                    toast.showInfo($translate.instant('file-transfer.file-was-uploaded'), null, $element.closest(".toast-parent"), 'bottom left');
                } else {
                    toast.showInfo(response, null, $element.closest(".toast-parent"), 'bottom left');
                }
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/gateway/file-transfer/file-transfer.directive.js